/* tslint:disable */
/* eslint-disable */
/**
 * ETL-API
 * Token gönderimi \"Authorization: Bearer {token}\" headeri ile veya \"access_token\" query parametresi ile yapılabilir
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import dayjs from "utils/dayjs";
import type { KokpitFeatureNameListDto } from './KokpitFeatureNameListDto';
import {
    KokpitFeatureNameListDtoFromJSON,
    KokpitFeatureNameListDtoFromJSONTyped,
    KokpitFeatureNameListDtoToJSON,
} from './KokpitFeatureNameListDto';

/**
 * 
 * @export
 * @interface KokpitFeatureUpdateDto
 */
export interface KokpitFeatureUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof KokpitFeatureUpdateDto
     */
    tenantId?: number;
    /**
     * 
     * @type {number}
     * @memberof KokpitFeatureUpdateDto
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureUpdateDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureUpdateDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof KokpitFeatureUpdateDto
     */
    featureKey?: string | null;
    /**
     * 
     * @type {Array<KokpitFeatureNameListDto>}
     * @memberof KokpitFeatureUpdateDto
     */
    dependencies?: Array<KokpitFeatureNameListDto> | null;
}

/**
 * Check if a given object implements the KokpitFeatureUpdateDto interface.
 */
export function instanceOfKokpitFeatureUpdateDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function KokpitFeatureUpdateDtoFromJSON(json: any): KokpitFeatureUpdateDto {
    return KokpitFeatureUpdateDtoFromJSONTyped(json, false);
}

export function KokpitFeatureUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): KokpitFeatureUpdateDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'tenantId': !exists(json, 'tenantId') ? undefined : json['tenantId'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'featureKey': !exists(json, 'featureKey') ? undefined : json['featureKey'],
        'dependencies': !exists(json, 'dependencies') ? undefined : (json['dependencies'] === null ? null : (json['dependencies'] as Array<any>).map(KokpitFeatureNameListDtoFromJSON)),
    };
}

export function KokpitFeatureUpdateDtoToJSON(value?: KokpitFeatureUpdateDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'tenantId': value.tenantId,
        'id': value.id,
        'name': value.name,
        'description': value.description,
        'featureKey': value.featureKey,
        'dependencies': value.dependencies === undefined ? undefined : (value.dependencies === null ? null : (value.dependencies as Array<any>).map(KokpitFeatureNameListDtoToJSON)),
    };
}

